import {
  EXPERIENCES_FETCH,
  EXPERIENCES_FETCH_FAILURE,
  EXPERIENCES_FETCH_SUCCESS,
  EXPERIENCE_COMPLETE,
  EXPERIENCE_COMPLETE_FAILURE,
  EXPERIENCE_COMPLETE_SUCCESS,
} from './types';

export function fetchExperiences() {
  return {
    type: EXPERIENCES_FETCH,
  };
}

export function fetchExperiencesSuccess(experiences) {
  return {
    type: EXPERIENCES_FETCH_SUCCESS,
    payload: {
      experiences,
    },
  };
}

export function fetchExperiencesFailure(error) {
  return {
    type: EXPERIENCES_FETCH_FAILURE,
    error: true,
    payload: error,
  };
}

export function completeExperience(key) {
  return {
    type: EXPERIENCE_COMPLETE,
    payload: {
      key,
    },
  };
}

export function completeExperienceSuccess(experience) {
  return {
    type: EXPERIENCE_COMPLETE_SUCCESS,
    payload: {
      experience,
    },
  };
}

export function completeExperienceFailure(error) {
  return {
    type: EXPERIENCE_COMPLETE_FAILURE,
    error: true,
    payload: error,
  };
}
